(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("d3"), require("vue-resize-directive"), require("vue"));
	else if(typeof define === 'function' && define.amd)
		define(["d3", "vue-resize-directive", "vue"], factory);
	else if(typeof exports === 'object')
		exports["vueD3Tree"] = factory(require("d3"), require("vue-resize-directive"), require("vue"));
	else
		root["vueD3Tree"] = factory(root["d3"], root["Vueresize"], root["Vue"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_48__, __WEBPACK_EXTERNAL_MODULE_77__, __WEBPACK_EXTERNAL_MODULE_142__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition